import dayjs from 'dayjs';

export const OUTCOMES = ['win', 'loss', 'inconclusive', 'invalid'];
export const IN_FLIGHT = ['PLANNING', 'BUILD_QA', 'SCHEDULED', 'LIVE', 'ANALYSING'];

export const OUTCOME_STYLES = {
    win: 'bg-primary',
    loss: 'bg-primary-muted',
    inconclusive: 'bg-primary-soft',
    invalid: 'border border-dashed border-gray-400 bg-white',
};

export const getVerdictOutcome = (test) => {
    const raw = test?.verdict?.status || test?.ideation?.structure?.result?.verdict;
    const status = String(raw || '').toLowerCase().trim();
    return OUTCOMES.includes(status) ? status : null;
};

export const getTestDate = (test) => {
    const raw = test?.concluded_at
        || test?.schedule?.end_date_time
        || test?.schedule?.date_time
        || test?.updatedAt
        || test?.updated_at
        || test?.createdAt
        || test?.created_at;
    if (raw && dayjs(raw).isValid()) {
        return dayjs(raw);
    }
    const sched = test?.ideation?.structure?.schedule || test?.structure?.schedule;
    if (sched?.end_day != null) {
        return dayjs().startOf('day').add(sched.end_day, 'day');
    }
    if (sched?.start_day != null) {
        return dayjs().startOf('day').add(sched.start_day, 'day');
    }
    return null;
};

export const isTestInTimeframe = (test, timeframeKey) => {
    const testDate = getTestDate(test);
    if (!testDate) return true;
    const now = dayjs();
    switch (timeframeKey) {
        case '4_weeks': {
            const cutoff = now.subtract(4, 'week').startOf('day');
            return testDate.isAfter(cutoff) || testDate.isSame(cutoff);
        }
        case '1_quarter': {
            const cutoff = now.subtract(3, 'month').startOf('day');
            return testDate.isAfter(cutoff) || testDate.isSame(cutoff);
        }
        case '2_quarters': {
            const cutoff = now.subtract(6, 'month').startOf('day');
            return testDate.isAfter(cutoff) || testDate.isSame(cutoff);
        }
        case '4_quarters': {
            const cutoff = now.subtract(12, 'month').startOf('day');
            return testDate.isAfter(cutoff) || testDate.isSame(cutoff);
        }
        default:
            return true;
    }
};

